/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';
import { SegmentedControl as MantineSegmentedControl } from '@mantine/core';

// App
import LegacyMantineProvider from './Provider';

/*----------------------------------
- TYPES
----------------------------------*/

export type Props = React.ComponentProps<typeof MantineSegmentedControl>;

/*----------------------------------
- COMPONENT
----------------------------------*/
export default function SegmentedControl(props: Props) {
    return (
        <LegacyMantineProvider>
            <MantineSegmentedControl {...props} />
        </LegacyMantineProvider>
    );
}
